


// import React, { useState } from "react";
import { useState } from "react";
import { decrypt } from "../../../../Services/cryptoUtils";
import './busca.css';

function BuscaEmpresa({ onEmpresaPesquisada }) {
    const [usu_cidade, setUsu_Cidade] = useState(() => {
        const encryptedUser = localStorage.getItem('tokenacw');
        if (encryptedUser) {
            try {
                const decryptedUser = decrypt(encryptedUser);
                return decryptedUser.cidade || '';
            } catch (error) {
                console.error('Erro ao descriptografar ou fazer o parse dos dados:', error);
                return '';
            }
        }
        return '';
    });
        // const user = localStorage.getItem("usuario");
        // // Converter a string JSON para um objeto
        // const userObject = JSON.parse(user);
        // // Acessar a propriedade cidade do objeto
        // const [usu_cidade, setUsu_Cidade] = useState(userObject ? userObject.cidade : '');
        // const [cidade, setCidade] = useState(usu_cidade);
        
        const [empresa, setEmpresa] = useState('');

        const handlePesquisar = () => {
          const empresaMaiuscula = empresa.toUpperCase();
        //   if (empresaMaiuscula) {
            onEmpresaPesquisada(empresaMaiuscula); // Chama a função passada como props com a cidade em maiúsculo
        //   }
        };

        const handleKeyPress = (event) => {
            if (event.key === 'Enter') {
              handlePesquisar();
            }
        };
        
      
    return <>
        {/* <div className="topo-margin"> */}
        <div className="container-fluid">
        <div className="row">
            <div className="col-md-5">
                <h5>Negócio ou Empresa</h5>
            </div>
            <div className="col-md-7">
                <div className="input-group mb-3">
                    <input 
                        type="text" 
                        className="form-control" 
                        placeholder="digite a empresa que você deseja filtrar..."
                        value={empresa}
                        onChange={(e) => setEmpresa(e.target.value)}
                        onKeyPress={handleKeyPress} // Adiciona o manipulador de tecla
                        aria-describedby="button-addon2"
                        aria-label="Username" 
                        // disabled // temporariamente 7/6/24w
                    />
                    <button 
                        className="btn btn-outline-danger" 
                        type="button" 
                        id="button-busca-empresa" 
                        onClick={handlePesquisar}
                        // disabled
                    >
                        <i className="fas fa-search"> Buscar</i>
                    </button>
                </div>
            </div>
        </div>
        </div>
        {/* </div> */}
        </>
}

export default BuscaEmpresa;